module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"メールアドレスまたはアカウント":"メールアドレスまたはアカウント","パスワードをお忘れの方":"パスワードをお忘れの方"},"en":{"メールアドレスまたはアカウント":"Email address or account","パスワードをお忘れの方":"Forgot your password?"}}')
  delete Component.options._Ctor
}
